import { render } from "./AccountMenuItemLink.vue?vue&type=template&id=4673b065&scoped=true"
import script from "./AccountMenuItemLink.vue?vue&type=script&lang=js"
export * from "./AccountMenuItemLink.vue?vue&type=script&lang=js"

import "./AccountMenuItemLink.vue?vue&type=style&index=0&id=4673b065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4673b065"]])

export default __exports__